module.exports = __webpack_public_path__ + "static/media/2.23.9c8f2245.png";